import { render } from "./9SocialSection.vue?vue&type=template&id=6fdfd1f1&scoped=true"
import script from "./9SocialSection.vue?vue&type=script&lang=js"
export * from "./9SocialSection.vue?vue&type=script&lang=js"

import "./9SocialSection.vue?vue&type=style&index=0&id=6fdfd1f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdfd1f1"]])

export default __exports__